import React, { useState, useRef, useEffect, useContext } from "react";
import { uploadImage } from "../../../_api";
import html2canvas from "html2canvas";
import Modal from "react-modal";
import { customModalStyles, photoboothName } from "../../../utils/fixers";
import { saveAs } from "file-saver";
import Frames from "../../../Assets/Frames";
import ButtonLoader from "../../../components/ButtonLoader";
import uploadIcon from "../../../Assets/img/upload-icon.png";
import ImageCropper from "../ImageCropper";
import { UserContext } from "../../../context";
import useWindowDimensions from "../../../components/dimensions";

export default function Capture() {
  const imageFrameRef = useRef(null);
  const imageRef = useRef(null);

  const { width } = useWindowDimensions();

  const { user } = useContext(UserContext);

  const [selectedFrame, selectFrame] = useState(Frames[0]);
  const [loading, setLoading] = useState(false);
  const [link, setLink] = useState(null);
  const [url, setUrl] = useState(null);
  const [camImage, setCamImage] = useState(null);
  const [camImageWithBg, setCamImageWithBg] = useState(null);
  const [progress, setProgress] = useState(0);
  const [imgCompress, setImgCompress] = useState(null);
  const [imageHeight, setImageHeight] = useState(0);
  const [imageWidth, setImageWidth] = useState(0);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [images, setImages] = useState(["", "", "", "", ""]);
  const [fileInput, setFileInput] = useState(true);
  const [currIndex, setCurrIndex] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null);

  const uploadBtnRef = useRef(null);

  function handleImageHeight() {
    setImageHeight(imageRef.current.clientHeight);
    setImageWidth(imageRef.current.clientWidth);
  }

  const handleChangeFile = ({ target }) => {
    if (target.files.length) {
      let file = URL.createObjectURL(target.files[0]);
      setUploadedImage(file);
    }
  };

  const clickAgain = () => {
    selectFrame(Frames[0]);
    setCamImage(null);
    setCamImageWithBg(null);
    setProgress(0);
    setUrl(null);
    setProgress(0);
    setError(null);
    setSuccess(null);
    setLoading(false);
    setLink(null);
    setUploadedImage(null);
    setCurrIndex(null);
    setImages(["", "", "", "", ""]);
  };

  const handleImageUpload = async () => {
    if (!loading) {
      setLoading(true);
      html2canvas(imageFrameRef.current, { scale: 2 }).then(function (canvas) {
        const dataURL = canvas.toDataURL("image/jpeg");
        changeDataUrlToBlob(dataURL);
      });
    }
  };

  const changeDataUrlToBlob = async (url) => {
    let blob = await fetch(url);
    blob = await blob.blob();
    setImgCompress(url);
    uploadFinalImage(blob);
  };

  const uploadFinalImage = (dataURL) => {
    const body = new FormData();
    body.append("photo", dataURL);
    body.append("name", user.name);
    body.append("email", user.email);

    uploadImage({
      body,
      setLoading,
      setLink,
    });
  };

  useEffect(() => {
    if (link === true) {
      setCamImageWithBg(imgCompress);
    }
  }, [link]); // eslint-disable-line

  useEffect(() => {
    document.title = "Healthy Wali Diwali";
    window.scrollTo(0, 0);
  }, []); // eslint-disable-line

  const handleImageDownload = () => {
    saveAs(imgCompress, `${photoboothName}.png`);
  };

  const handleShareImage = async () => {
    const response = await fetch(imgCompress);
    const blob = await response.blob();

    if (navigator.share) {
      await navigator
        .share({
          title: "",
          text: "",
          url: "",
          files: [
            new File([blob], "healthywalidiwali.png", {
              type: blob.type,
            }),
          ],
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error in sharing", error));
    } else {
      console.log(`system does not support sharing files.`);
    }
  };

  const handleCloseModel = () => {
    setUploadedImage(null);
  };

  const CaptureActionBlock = () => (
    <div
      className="actionBlock"
      // style={{ top: imageHeight - 120, justifyContent: "flex-start" }}
      style={{ bottom: 40, justifyContent: "flex-start" }}
    >
      <div
        className="text-center mT30 mB30 btnsOuter"
        style={{ flexWrap: "wrap" }}
      >
        {!!link && (
          <button
            type="button"
            className={`${width > 467 ? "login-btn small" : "newBtn"}${
              loading ||
              !images[0] ||
              !images[1] ||
              !images[2] ||
              !images[3] ||
              !images[4]
                ? " disabled"
                : ""
            }`}
            onClick={clickAgain}
            disabled={
              loading ||
              !images[0] ||
              !images[1] ||
              !images[2] ||
              !images[3] ||
              !images[4]
            }
            style={{ marginRight: 8 }}
          >
            Re-Upload
          </button>
        )}
        <button
          type="button"
          className={`${width > 467 ? "login-btn small" : "newBtn"}${
            loading ||
            !images[0] ||
            !images[1] ||
            !images[2] ||
            !images[3] ||
            !images[4]
              ? " disabled"
              : ""
          }`}
          onClick={link ? handleShareImage : handleImageUpload}
          disabled={
            loading ||
            !images[0] ||
            !images[1] ||
            !images[2] ||
            !images[3] ||
            !images[4]
          }
          style={
            images?.length !== 5 || loading
              ? { opacity: 0.7, cursor: "not-allowed" }
              : {}
          }
        >
          {link ? "Share" : "Submit"} {loading ? <ButtonLoader /> : null}
        </button>
        {camImageWithBg ? (
          <button
            type="button"
            className={`${width > 467 ? "login-btn small" : "newBtn"}${
              loading ? " disabled" : ""
            }`}
            onClick={handleImageDownload}
            disabled={loading}
            style={{ marginTop: 10, marginLeft: 8 }}
          >
            Download
          </button>
        ) : null}
      </div>
      {error && <div className="api-error ">{error}</div>}
      {success && <div className="api-success ">{success}</div>}
    </div>
  );

  const renderInitial = () => (
    <>
      <div
        className={`framephotobooth noShape ${camImage ? "finalView" : ""}`}
        style={
          imageHeight
            ? { height: imageHeight, width: imageWidth, margin: 0 }
            : { margin: 0 }
        }
      >
        <div
          className="descpertionSec takephotoSec"
          style={imageHeight ? { height: imageHeight, width: imageWidth } : {}}
          ref={imageFrameRef}
        >
          {/* {camImage ? (
            <div className="pictureArea dynmaicBg">
              <img className="capturePic" src={camImage} alt="" />
            </div>
          ) : imageHeight ? (
            <>
              <div className={camImageWithBg ? "d-none" : ""}>
                <Webcam
                  {...webCamSettings}
                  videoConstraints={{
                    facingMode: "user",
                  }}
                  mirrored={true}
                  ref={webCamRef}
                  width={{ min: 10, ideal: 1080, max: 1920 }}
                  height={{ min: 57, ideal: 1920, max: 1080 }}
                />
              </div>
              <img
                // style={{ transform: "scaleX(-1)" }}
                className={camImageWithBg ? "capturePic" : "d-none"}
                src={camImageWithBg}
                alt=""
              />
            </>
          ) : null} */}

          <div
            className="frameV2"
            style={
              !!imageHeight
                ? { height: imageHeight, width: imageWidth, maxHeight: "90vh" }
                : { maxHeight: "90vh" }
            }
          >
            <img
              ref={imageRef}
              className="capturePic"
              onLoad={handleImageHeight}
              src={selectedFrame}
              alt=""
              style={width > 400 ? { maxHeight: "95vh" } : {}}
            />
            <div
              className="imgs-cont"
              style={{ height: imageHeight, width: imageWidth }}
            >
              {images.map((image, index) => (
                <div
                  className={`img-up img-${index + 1}`}
                  onClick={() => {
                    if (link) return;
                    uploadBtnRef.current.click();
                    setCurrIndex(index);
                  }}
                  key={index}
                >
                  <img
                    style={
                      !image?.length
                        ? { width: width > 400 ? 40 : 60 }
                        : { width: 100, height: 100 }
                    }
                    src={image || uploadIcon}
                    alt=""
                  />
                </div>
              ))}
              {fileInput && (
                <input
                  accept=".jpg,.jpeg,.png,.jfif,.webp"
                  hidden
                  name="myImage"
                  onChange={handleChangeFile}
                  ref={uploadBtnRef}
                  type="file"
                />
              )}
              {!images[0] ||
              !images[1] ||
              !images[2] ||
              !images[3] ||
              !images[4] ? (
                <span
                  style={{
                    color: "red",
                    fontSize: 12,
                    position: "absolute",
                    bottom: -20,
                    left: 0,
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  *Please upload all 5 images to submit
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {progress === 0 && imageHeight ? <CaptureActionBlock /> : null}
    </>
  );

  return (
    <section className="wrapper ellipse-bg">
      <div className="container">
        <div
          className="framephotoboothOuter"
          style={{ justifyContent: "unset" }}
        >
          <div className="fixedActions">
            {/* <button
              className="rippleBtn"
              disabled={loading}
              onClick={() => navigate("/gallery")}
            >
              Gallery
            </button> */}
          </div>
          {renderInitial()}
        </div>
      </div>

      <Modal
        ariaHideApp={false}
        className="modal2"
        isOpen={!!uploadedImage}
        onRequestClose={handleCloseModel}
        overlayClassName="overlay2"
        style={customModalStyles}
      >
        <div className="text-center ">
          <div>
            <img src={url} alt="" />
          </div>
          <ImageCropper
            image={uploadedImage}
            setImage={(image) => {
              if (image) {
                setImages((prev) =>
                  prev.map((img, index) => (index === currIndex ? image : img))
                );
              }
              setUploadedImage(null);
              setCurrIndex(null);
            }}
            setFileInput={setFileInput}
          />
        </div>
      </Modal>

      {/* <div id="warning-message">
        This photo-booth is only viewable in mobile portrait mode.
      </div> */}
    </section>
  );
}
